<template>
  <div class="container-fluid">
    <div class="row" :style="{
      backgroundImage:
        'url(' + require('../assets/images/login/bg.png') + ')',
    }" style="background-size: 787px 100vh; background-repeat: no-repeat">
      <div
        class="login-title-container col-auto b-center bg-size d-flex flex-column justify-content-center align-items-start text-white position-relative">
        <div class="badge-logo d-flex justify-content-center align-items-center">
          <img src="@/assets/images/login/vectolabs_icon.png" alt="Vectolabs" />
        </div>
        <h2 class="f-w-600">WELCOME BACK!</h2>
        <h1>Urbanlume - SSL</h1>
        <span class="line-spacer"></span>
        <h2 class="f-w-600">You can sign in to access your existing account</h2>
      </div>
      <div class="col p-0">
        <div class="login-card">
          <div class="login-main">
            <form class="theme-form">
              <h2 class="f-w-600 color-gray-1 pb-2 mb-4">SIGN IN</h2>
              <div class="form-group">
                <input class="form-control btn-pill f-w-300" type="email" required="" placeholder="username or email"
                  v-model="user.email.value" />
                <i class="icofont icofont-user-alt-7"></i>
                <span class="validate-error" v-if="!user.email.value || !validEmail(user.email.value)">{{
                  user.email.errormsg }}</span>
              </div>
              <div class="form-group">
                <div class="form-input position-relative">
                  <input class="form-control btn-pill f-w-300" :type="active ? 'password' : 'text'"
                    name="login[password]" required="" placeholder="password" v-model="user.password.value" />
                  <i class="icofont icofont-ui-lock"></i><span class="validate-error"
                    v-if="user.password.value.length < 7">{{ user.password.errormsg }}</span>
                  <div class="show-hide d-none">
                    <span class="show" :class="active ? 'show' : 'hide'" @click.prevent="show">
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group mb-0">
                <span v-if="errorMsg" class="text-danger">{{ errorMsg }}</span>
                <div class="checkbox p-0 ps-1">
                  <input id="checkbox1" type="checkbox" />
                  <label class="text-remember-forgot f-w-600" for="checkbox1">Remember me</label>
                </div>
                <router-link to="/" class="link text-remember-forgot f-w-600">Forgot password?</router-link>
                <div class="text-end mt-3">
                  <router-link to="/">
                    <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="login">
                      Sign in
                    </button></router-link>
                </div>
              </div>
              <h6 class="mt-4 other-login"><span>or sign in with</span></h6>
              <div class="social mt-4">
                <div class="btn-showcase text-center">
                  <img src="@/assets/images/login/microsoft.png" alt="Azure" class="clickable-img border rounded-circle"
                    @click="loginWithMicrosoft" />
                  <!-- <a class="btn btn-link" href="#">
                    <img src="@/assets/images/login/azure.png" alt="Azure" />
                  </a> -->
                </div>
              </div>
              <!-- <p class="mt-5 mb-0 text-center">
                Don't Have An Account?
                <router-link class="ms-2 green-color" to="/auth/register"
                  >Register Here</router-link
                >
              </p> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { credentialSignInService, MicrosoftOAuthLink } from "./authStore";
import { setCookies, removeCookies } from "../utils";

export default {
  name: "login",
  data() {
    return {
      active: true,
      useMock: false,
      errorMsg: "",
      user: {
        email: {
          // value: "mrantiadmin@vectolabs.com",
          value: "",
          errormsg: "",
        },
        password: {
          value: "",
          errormsg: "",
        },
      },
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.showLoginError(urlParams.get("error"))

    removeCookies("version")
  },
  methods: {
    loginWithMicrosoft() {
      // console.log("login with microsoft")
      const loginMC = MicrosoftOAuthLink(window.location.origin + "/oauth", window.location.origin + "/auth/login?error=Missing permission, please contact system administrator.", "streetlight");
      // const loginMC = MicrosoftOAuthLink("http://localhost:8887/oauth", "http://localhost:8887/auth/login?error=Missing permission, please contact system administrator.", "streetlight");


      // console.log(loginMC)
      window.location.href = loginMC;
    },
    show() {
      this.active = !this.active;
    },
    showLoginError(message) {
      this.errorMsg = message
      setTimeout(() => {
        this.errorMsg = ""
      }, 5000)
    },
    async login() {
      if (!this.user.password.value) {
        this.user.password.errormsg = "empty not allowed";
      } else {
        this.user.password.errormsg = "";
      }

      if (!this.user.email.value) {
        this.user.email.errormsg = "empty not allowed";
      } else if (!this.validEmail(this.user.email.value)) {
        this.user.email.errormsg = "Valid email required.";
      } else {
        this.user.email.errormsg = "";
      }

      if (
        this.user.email.errormsg === "" &&
        this.user.password.errormsg === ""
      ) {
        if (this.useMock) {
          if (
            !this.user.email.errormsg &&
            !this.user.password.errormsg &&
            this.user.email.value == "test@123.com" &&
            this.user.password.value == "test123"
          ) {
            this.result = {
              email: this.user.email.value,
              password: this.user.password.value,
            };

            localStorage.setItem(
              "User",
              JSON.stringify({ email: this.user.email.value, useer: true })
            );
            this.logging = true;
            this.$router.push("/V2/totalsolution");
          }
          return;
        }

        let resp = await credentialSignInService({
          email: this.user.email.value,
          password: this.user.password.value,
          service: "streetlight",
        });

        if (!resp) {
          this.showLoginError(resp?.error || "invalid credentials")
          return
        }

        setCookies("token", resp.token);
        setCookies("session", resp.session);

        localStorage.setItem("User", resp.token);
        sessionStorage.setItem("token", resp.token);
        this.logging = true;
        this.$router.push("/V2/totalsolution");
      }
    },
    validEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: #fff;
  font-family: Poppins;
  font-size: 70px;
  font-style: normal;
  font-weight: 600;
  line-height: 70px;
  text-transform: uppercase;
}

h2 {
  color: #fff;
  font-family: Poppins;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 150.03%;
  /* 60.012px */
}

.green-color {
  color: #009a78;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.badge-logo {
  width: 217px;
  height: 102px;
  border-radius: 0px 0px 12px 12px;
  background: #fff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
  position: absolute;
  top: 0;
  left: 48px;

  img {
    width: 176px;
  }
}

.btn-link img {
  width: 33.75px;
  height: 33.75px;
  object-fit: contain;
}

.login-title-container {
  padding: 0 54px;
  width: 787px;
}

.line-spacer {
  width: 303.75px;
  height: 3.75px;
  margin: 19.5px 0;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 4.5px;
  opacity: 0.5;
}

.btn-primary {
  border-radius: 41px;
  background: linear-gradient(180deg, #009a78 0%, #a6cee3 100%);
  height: 82px;
  border: none;
  color: #ffffff;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.validate-error {
  color: #dc3545;
}

.login-card {
  background: white;
  padding: 0;

  .login-main {
    width: 100%;
    box-shadow: none;

    .theme-form {
      width: 486px;
      margin: 0 auto;
    }

    .theme-form .form-control {
      height: 82px;
      border-radius: 41px;
      border: 1px solid #b4b5b7;
      background: #fff;
      padding-left: 60.75px;
      letter-spacing: 0.5625px;
      color: #b4b6b8;
      font-size: 18.75px;
      line-height: 28.5px;
    }

    .theme-form input::placeholder {
      color: #b4b5b7;
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
    }

    .theme-form .form-group {
      margin-bottom: 28px;
    }

    .theme-form .checkbox label::before {
      border-radius: 50%;
      border: 1px solid #b4b5b7;
      top: 5px;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translate(0, -10px);
      background: white;
    }

    .theme-form .text-remember-forgot {
      color: #9b9a9a;
      font-family: Poppins;
      font-size: 17px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      padding-left: 34px;
    }
  }
}

.color-gray-1 {
  color: #9b9a9a;
  font-family: Poppins;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.form-group i {
  position: absolute;
  top: 0;
  pointer-events: none;
  font-size: 25.5px;
  padding-left: 21.75px;
  opacity: 0.5;
  height: 82px;
  display: flex;
  align-items: center;
}

.other-login {
  text-align: center;
  border-bottom: 1px solid #707070;
  line-height: 0.1em;
  margin: 28.5px 0 22.5px;
  color: #ababab;
  font-size: 12.75px;

  span {
    background: white;
    padding: 0 18px;
  }
}

.clickable-img {
  cursor: pointer;
  width: 50px;
  /* or whatever size */
  height: auto;
}
</style>
